import { Injectable } from '@angular/core';

import { RedactorConfig } from '../../redactor.types';
import { mergeRedactorConfigArrField, RedactorExtension } from '../redactor-extension';

// plugin tokens
export const SIGNATURE_PLUGIN_TOKEN = 'rt-signature';
// trigger block class name
/*
 * @desc This value is hardcoded in redactor
 */
export const SIGNATURE_DEFAULT_CLASS = 'recruitee-email-signature';
export const FORWARD_DEFAULT_CLASS = 'recruitee-forward';
export const QUOTE_DEFAULT_CLASS = 'recruitee-quote';

@Injectable({
  providedIn: 'root',
})
export class RedactorSignatureExtension extends RedactorExtension {
  constructor() {
    super();
  }

  public canInstall(config: RedactorConfig): boolean {
    return Array.isArray(config.plugins) && config.plugins.includes(SIGNATURE_PLUGIN_TOKEN);
  }

  public install(config: RedactorConfig): RedactorConfig {
    this.enable();

    const pasteKeepSelector = `div.${SIGNATURE_DEFAULT_CLASS}`;

    return {
      ...config,
      pasteKeepStyle: mergeRedactorConfigArrField(config, 'pasteKeepStyle', [
        'table',
        'td',
        'tr',
        'thead',
        'tbody',
      ]),
      pasteBlockTags: mergeRedactorConfigArrField(config, 'pasteBlockTags', [
        'table',
        'td',
        'tr',
        'thead',
        'tbody',
      ]),
      pasteKeepClass: mergeRedactorConfigArrField(config, 'pasteKeepClass', [pasteKeepSelector]),
      pasteKeepAttrs: mergeRedactorConfigArrField(config, 'pasteKeepAttrs', [pasteKeepSelector]),
    };
  }
}
